module.exports = __webpack_public_path__ + "static/img/pingjiaimg.1dcdc07c.png";